import React from 'react'
import { Link } from 'react-router-dom'

const RecruiterModal = ({setShowLogoutModal}) => {
  return (
    <div className="absolute top-16 right-20 bg-white rounded-lg shadow border z-10 whitespace-nowrap overflow-hidden">
    <Link to={`/mira-recruteur/profile`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Tableau de bord
      </div>
    </Link>
    <hr />
    <Link to={`/mira-recruteur/offre/nouveau`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Publier une offre
      </div>
    </Link>
    <Link to={`/mira-recruteur/offre`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Recrutement
      </div>
    </Link>
    <Link to={`/mira-recruteur/candidat`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Mes candidats
      </div>
    </Link>
    <Link to={`/mira-recruteur/abonnement`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      abonnement
      </div>
    </Link>
    <hr/>
    <button
    onClick={()=>setShowLogoutModal(true)}
      className="w-full text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center"
    >
      Se déconnecter
    </button>
  </div>
  )
}

export default RecruiterModal